<template>
    <div>

        <widget id="meter-list"
                :title="title"
                :paginator="true"
                :paging_url="meterService.pagingUrl"
                :route_name="meterService.routeName"
                :show_per_page="true"
                :subscriber="subscriber"
                color="green"
                @widgetAction="syncMeters()"
                :button="true"
                buttonIcon="cloud_download"
                :button-text="buttonText"
                :emptyStateLabel="label"
                :emptyStateButtonText="buttonText"
                :newRecordButton="false"
        >

            <md-table v-model="meterService.list" md-sort="id" md-sort-order="asc" md-card>
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="ID" md-sort-by="id">{{ item.id }}</md-table-cell>
                    <md-table-cell md-label="Serial" md-sort-by="serial">{{ item.serial }}</md-table-cell>
                    <md-table-cell md-label="Site" md-sort-by="site">{{ item.site }}</md-table-cell>
                    <md-table-cell md-label="Customer" md-sort-by="owner">{{ item.owner}}</md-table-cell>
                </md-table-row>
            </md-table>

        </widget>
        <md-progress-bar md-mode="indeterminate" v-if="loading"/>
        <redirection :redirection-url="redirectionUrl" :dialog-active="redirectDialogActive"/>
    </div>
</template>

<script>
import Redirection from '../Shared/Redirection'
import { SiteService } from '../../services/SiteService'
import { EventBus } from '../../eventbus'
import { CredentialService } from '../../services/CredentialService'
import Widget from '../Shared/Widget'
import { CustomerService } from '../../services/CustomerService'
import { MeterService } from '../../services/MeterService'

export default {
    name: 'MeterList',
    components: { Redirection, Widget },
    data () {
        return {
            credentialService: new CredentialService(),
            siteService: new SiteService(),
            customerService: new CustomerService(),
            meterService: new MeterService(),
            subscriber: 'meter-list',
            loading: false,
            isSynced: false,
            title: 'Meters',
            redirectionUrl: '/steama-meters/steama-overview',
            redirectDialogActive: false,
            buttonText: 'Get Updates From Steama.co',
            label: 'Meter Records Not Up to Date.'
        }
    },
    mounted () {
        this.checkCredential()
        EventBus.$on('pageLoaded', this.reloadList)
    },
    beforeDestroy () {
        EventBus.$off('pageLoaded', this.reloadList)
    },
    methods: {
        async checkCredential () {
            try {
                await this.credentialService.getCredential()
                if (!this.credentialService.credential.isAuthenticated) {
                    this.redirectDialogActive = true
                } else {
                    await this.checkSync()
                }

            } catch (e) {
                this.redirectDialogActive = true
            }
        },
        async checkSync () {
            try {
                this.loading = true
                this.isSynced = await this.meterService.checkMeters()
                this.loading = false

                if (!this.isSynced) {
                    let swalOptions = {
                        title: 'Updates',
                        showCancelButton: true,
                        text: 'Meter Records Not Up to Date.',
                        confirmButtonText: 'Update',
                        cancelButtonText: 'Cancel',
                    }
                    this.$swal(
                        swalOptions
                    ).then((result) => {
                        if (result.value) {
                            this.syncMeters()
                        }
                    })
                }
            } catch (e) {
                this.loading = false
                this.alertNotify('error', e.message)
            }
        },
        async syncMeters () {
            if (!this.loading) {
                try {
                    this.loading = true
                    let sitesSynced = await this.siteService.checkSites()
                    if (!sitesSynced) {
                        this.alertNotify('warn', 'Sites must be updated to update Meters.')
                        this.isSynced = false
                        return
                    }
                    let customersSynced = await this.customerService.checkCustomers()
                    if (!customersSynced) {
                        this.alertNotify('warn', 'Customers must be updated to update Meters.')
                        this.isSynced = false
                        return
                    }
                    this.isSynced = false
                    await this.meterService.syncMeters()
                    EventBus.$emit('widgetContentLoaded', this.subscriber, 1)
                    this.isSynced = true
                    this.loading = false
                } catch (e) {
                    this.loading = false
                    this.alertNotify('error', e.message)
                }
            }

        },
        reloadList (subscriber, data) {
            if (subscriber !== this.subscriber) return
            this.meterService.updateList(data)
            EventBus.$emit('widgetContentLoaded', this.subscriber, this.meterService.list.length)
        },
        alertNotify (type, message) {
            this.$notify({
                group: 'notify',
                type: type,
                title: type + ' !',
                text: message
            })
        },
    }
}
</script>

<style scoped>

</style>